import React from "react";
import { useState, useEffect } from "react";

import usePatientRequests from "../hooks/patient-requests";
import { useAlert } from "../context/alert-context";

import styles from "./Modal_Components.module.css";
import Loading from "../pop-ups/loading";

const EditNote = ({modalProps, accessToken, closeModal}) => {
  const { updatePatient } = usePatientRequests();
  const { showAlert } = useAlert();

  const [patientNote, setPatientNote] = useState({
    noteId: modalProps.editId,
    noteDate: undefined,
    note: undefined
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; 
    const day = currentDate.getDate();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();

    const date = `${month}/${day}/${year} ${hours}:${minutes}`

    const noteValue = modalProps.patientData.notes.find((note) => {
      return note.noteId === modalProps.editId;
    });

    setPatientNote((prev) => ({
      ...prev,
      noteDate: date,
      note: noteValue.note
    }));
  }, [modalProps.patientData]);

  const handleNoteChanges = (event) => {
    const {value} = event.target;

    setPatientNote((prev) => ({
      ...prev,
      note: value
    }));
  };

  const handleSaveNote = async () => {
    setIsLoading(true);
    const index = modalProps.patientData.notes.findIndex((note) => note.noteId === modalProps.editId);
    const patientToUpdate = {...modalProps.patientData};
    patientToUpdate.notes[index] = patientNote;

    const response = await updatePatient(patientToUpdate, accessToken);
    if(response.status === 201) {
      showAlert('', 'Success!',  'success');
      setTimeout(() => {
        setIsLoading(false);
        closeModal();
      }, 800);

    } else {
      setIsLoading(false);
      showAlert(`ERROR: ${response.message}`, 'Oh, Snap!', 'danger');;
    }
  };

  if(isLoading) {
    return <div className="d-flex justify-content-center align-items-center h-100"><Loading /></div> 
  }

  return (
    <div>
      <div className="container">
        <div className="d-flex justify-content-center my-3">
          <textarea
            id={styles.newPatientNote}
            name="patientNote"
            placeholder="Jane Doe cannot be seen before 10am."
            className="mspTextArea"
            value={patientNote.note}
            onChange={handleNoteChanges}
            rows={5}
            />
        </div>
        <div className="d-flex justify-content-end my-2">
          <button 
            disabled={!patientNote.note}
            onClick={handleSaveNote} 
            className="primaryBtn">
              Save
          </button>
        </div>
      </div>
    </div>
  )
};

export default EditNote;